import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FilterVideo, VideoDetail } from '../../models/video'
import { environment } from '../../../environments/environment'
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-svideo',
  templateUrl: './svideo.component.html',
  styleUrls: ['./svideo.component.scss']
})
export class SvideoComponent implements OnInit {
  filterVideo: FilterVideo = {
    usePagination: true,
    orderField: 'FechaGrabacion',
    orderDirection: 'DESC',
    pageRecords: 10,
    pageIndex: '1',
    general: '',
    juzgadoCodList: 'ALL',
    useDateFilter: '1',
    lowerDate: '',
    upperDate: '',
    intervinienteNombre: '',
    procesoCod: '',
    etiqueta: '',
    district: '-1',
    area: '-1'
  }
  urlApi = environment.urlApiVideos.url;
  @Input("ProcedureValue") ProcedureValue
  editPermissions: boolean = false;

  modules = environment.modules;

  user_id:string;

  is_reserved:boolean = true;

  @Input('videos') videos: VideoDetail[]

  constructor(private router: Router,private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.user_id = localStorage.getItem('user_id');
    if(this.ProcedureValue.type != 'scheduler'){
      this.editPermissions = true;
    }

    console.log('info: ');
    console.log(this.videos);

  }


  getHour(hora: string): string {
    let splitHour = hora[0] + hora[1]
    let splitMin = hora[2] + hora[3]
    let time = ' AM'
    if (parseInt(splitHour) >= 12) {
      time = ' PM'
      if (parseInt(splitHour) > 12) {
        splitHour = String(parseInt(splitHour) - 12)
      }else{
        splitHour = String(parseInt(splitHour))
      }

    }

    return splitHour + ':' + splitMin + time
  }
  getProcess(process: string) {
    const lsform = localStorage.getItem('formSearch')
    if (lsform !== null) {
      this.filterVideo = JSON.parse(lsform)
    }
    this.filterVideo.procesoCod = process
    localStorage.setItem('formSearch', JSON.stringify(this.filterVideo))
    window.location.reload()
  }

  /* copyToClipboard(videoId: string) {
    const domain = window.location.origin; // Obtiene el dominio dinámicamente
    const textToCopy = `${domain}/public/detail/${videoId}`;

    navigator.clipboard.writeText(textToCopy).then(() => {
      this._snackBar.open('Enlace copiado.','',{duration:3000});
    }).catch(err => {
      console.error("Error al copiar:", err);
    });
  } */
  copyToClipboard(videoId: string) {
    const domain = window.location.origin;
    const textToCopy = `${domain}/public/detail/${videoId}`;

    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      this._snackBar.open('Enlace copiado.', '', { duration: 3000 });
    } catch (err) {
      console.error('Error al copiar:', err);
    }
    document.body.removeChild(textarea);
  }



}
